import { render } from "./PatientMeasurements.vue?vue&type=template&id=681507da&scoped=true"
import script from "./PatientMeasurements.vue?vue&type=script&lang=js"
export * from "./PatientMeasurements.vue?vue&type=script&lang=js"

import "./PatientMeasurements.vue?vue&type=style&index=0&id=681507da&land=css&lang=css"
import "./PatientMeasurements.vue?vue&type=style&index=1&id=681507da&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-681507da"]])

export default __exports__